import React from 'react';
import 'styles/utils/StringInputBox.styl';
import classNames from 'classnames';

/**
 * <StringInputBox /> renders a <input /> element with a placeholder using a specific mockup
 * style. Since the same style is replicated across the board in different components, we should
 * use this utility component to render all the plain <input /> elements
 */
export default class StringInputBox extends React.Component {
  onChangeInput = event => {
    this.props.onChange(event.currentTarget.value);
  };

  render() {
    const className = classNames('string-input-box', this.props.className);
    return (
      <div className={className}>
        <input
          placeholder={this.props.placeholder}
          value={this.props.value}
          onChange={this.onChangeInput}
        />
      </div>
    );
  }
}
